import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RecaptchaInterceptor } from './recaptcha.interceptor';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';
import { AuthorizationInterceptor } from './authorization.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: RecaptchaInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: LoadInterceptor, multi: true },
];
